export default "__VITE_ASSET__dc6be3cb__"